/* ==========================================================================
   4P CRO · Gravity Deken
   Ergaenzungen aus der Analyse vom 04.10.2026.
   Laeuft ausschliesslich zusaetzlich, ueberschreibt keine Theme-Logik.
   ========================================================================== */
(function () {
  'use strict';

  // Texte kommen aus den Sprachdateien (siehe theme.liquid), damit die
  // englische und franzoesische Fassung nicht auf Niederlaendisch kippt.
  var T = window.fourpTexte || {};
  var txtOder = function (schluessel, ersatz) {
    return T[schluessel] || ersatz;
  };

  var ready = function (fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  };

  /* ------------------------------------------------------------------
     1 · Klick auf die Sterne fuehrt zu den Bewertungen
     Der Text neben den Sternen bleibt unveraendert ("500.000+ tevreden
     klanten"), daran wird nichts geaendert.

     Der Klick wird bewusst ueber das Dokument abgefangen und nicht als
     Attribut auf dem Widget gesetzt: Loox rendert den Block nach dem
     Laden neu und setzt dabei eigene Attribute (role="figure"), wodurch
     alles ueberschrieben wuerde, was wir direkt am Widget setzen.
     ------------------------------------------------------------------ */
  function bewertungVerlinken() {
    var zielFinden = function () {
      return (
        document.querySelector('#looxReviews, #loox-reviews-feed, .loox-reviews-default, .loox-reviews') ||
        (function () {
          var abschnitte = document.querySelectorAll('.shopify-section');
          for (var i = 0; i < abschnitte.length; i++) {
            if (/loox/i.test(abschnitte[i].innerHTML)) return abschnitte[i];
          }
          return null;
        })()
      );
    };

    document.addEventListener('click', function (e) {
      var widget = e.target.closest
        ? e.target.closest('[data-testid="loox-rating-widget"], .loox-rating, [data-fourp-zu-reviews]')
        : null;
      if (!widget) return;
      // Innerhalb des Widgets liegende echte Links nicht abfangen
      if (!widget.hasAttribute('data-fourp-zu-reviews') && e.target.closest('a[href]')) return;
      var ziel = zielFinden();
      if (!ziel) return;
      e.preventDefault();
      ziel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ------------------------------------------------------------------
     2 · Mitlaufender Kaufbutton auf dem Handy
     Erscheint, sobald der eigentliche Kaufbutton aus dem Bild gescrollt ist,
     und loest exakt dieselbe Aktion aus.
     ------------------------------------------------------------------ */
  function stickyKaufleiste() {
    var leiste = document.querySelector('.fourp-sticky');
    if (!leiste) return;

    var form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
    var echterButton = document.querySelector('product-form button[name="add"]');
    if (!form || !echterButton) return;

    var btn = leiste.querySelector('.fourp-sticky__btn');
    var preisEl = leiste.querySelector('.fourp-sticky__preis');

    // Sichtbarkeit: Leiste zeigen, sobald der echte Kaufbutton nach oben aus
    // dem Bild gescrollt ist. Bewusst ueber die Scrollposition statt ueber
    // einen IntersectionObserver, weil der bei programmatischen Spruengen
    // nicht zuverlaessig ausloest.
    var pruefeSichtbarkeit = function () {
      var b = echterButton.getBoundingClientRect();
      var raus = b.bottom < 0;
      // Am Seitenende wieder ausblenden, dort steht der Footer
      var amEnde = window.scrollY + window.innerHeight > document.documentElement.scrollHeight - 160;
      leiste.classList.toggle('is-visible', raus && !amEnde);
    };

    // In der Theme-Vorschau legt Shopify unten eine eigene Leiste ("Draft")
    // ueber die Seite, genau dorthin, wo diese Leiste sitzt. Echte Besucher
    // sehen sie nie, wer die Vorschau prueft aber immer, und hielt die
    // Kaufleiste deshalb fuer nicht vorhanden. Solange die Vorschauleiste
    // da ist, sitzt die Kaufleiste direkt darueber.
    var vorschauAbstand = function () {
      var pb = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
      var h = 0;
      if (pb) {
        var r = pb.getBoundingClientRect();
        if (r.height > 0 && r.top < window.innerHeight) h = Math.max(0, window.innerHeight - r.top);
      }
      leiste.style.bottom = h ? h + 'px' : '';
    };
    vorschauAbstand();
    if (window.Shopify && (window.Shopify.designMode || /preview_theme_id/.test(document.cookie + location.search) || document.getElementById('PBarNextFrameWrapper'))) {
      setInterval(vorschauAbstand, 1000);
    } else {
      setTimeout(vorschauAbstand, 3000);
    }

    window.addEventListener('scroll', pruefeSichtbarkeit, { passive: true });
    window.addEventListener('resize', pruefeSichtbarkeit, { passive: true });
    pruefeSichtbarkeit();

    // Klick weiterreichen
    btn.addEventListener('click', function () {
      echterButton.click();
    });

    // Preis und Verfuegbarkeit mit der Variantenauswahl synchron halten
    var abgleichen = function () {
      var quelle = document.querySelector('.price__container .price-item--sale, .price__container .price-item--regular');
      if (quelle && preisEl) {
        var vorher = document.querySelector('.price__container .price-item--regular s, .price__container s');
        preisEl.innerHTML =
          quelle.textContent.trim() + (vorher ? ' <s>' + vorher.textContent.trim() + '</s>' : '');
      }
      var aus = echterButton.hasAttribute('disabled');
      btn.disabled = aus;
      btn.textContent = aus ? txtOder('uitverkocht', 'Uitverkocht') : btn.dataset.label || txtOder('kopen', 'In winkelwagen');
    };

    new MutationObserver(abgleichen).observe(document.querySelector('product-form'), {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });
    abgleichen();
  }

  /* ------------------------------------------------------------------
     3 · Zusatzverkauf: Artikel per Klick in den Warenkorb
     ------------------------------------------------------------------ */
  function upsellVerdrahten() {
    // Ueber das Dokument statt pro Knopf: Das Warenkorb-Pop-up wird nach
    // jeder Aenderung neu gerendert, direkt gebundene Knoepfe waeren danach
    // tot.
    document.addEventListener('click', function (e) {
      var pfeil = e.target.closest ? e.target.closest('.fourp-upsell__pfeil') : null;
      if (pfeil) {
        var liste = pfeil.closest('.fourp-upsell').querySelector('.fourp-upsell__liste');
        var karte = liste.querySelector('.fourp-upsell__item');
        var schritt = karte ? (karte.getBoundingClientRect().width + 12) * 2 : liste.clientWidth * 0.8;
        liste.scrollBy({ left: schritt * Number(pfeil.dataset.richtung || 1), behavior: 'smooth' });
        return;
      }

      var btn = e.target.closest ? e.target.closest('.fourp-upsell__btn') : null;
      if (!btn || btn.disabled) return;
      e.preventDefault();

      // Passende Variante bestimmen (Groesse und Systeem der Deken). Laesst
      // sie sich nicht eindeutig bestimmen, zur Produktseite statt raten.
      var karte = btn.closest('.fourp-upsell__item');
      var id = btn.getAttribute('data-variant-id');
      if (karte && karte.dataset.varianten) {
        var wahl = upsellWahl(karte);
        if (wahl === 'kiezen') {
          window.location.href = karte.dataset.url;
          return;
        }
        if (wahl) id = String(wahl.id);
      }
      if (!id) return;

      var plus = btn.classList.contains('fourp-upsell__btn--plus');
      var urspruenglich = btn.textContent;
      btn.disabled = true;
      if (!plus) btn.textContent = txtOder('bezig', 'Bezig...');

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          btn.classList.add('is-toegevoegd');
          btn.textContent = plus ? '✓' : txtOder('klaar', 'Toegevoegd ✓');
          btn.disabled = false;
          aktualisiereWarenkorbZahl();
          // Auf der Warenkorbseite neu laden, damit Artikel und Summe
          // stimmen. Der Pfad kann ein Sprachpraefix haben (/en/cart,
          // /fr/cart), deshalb nicht auf den Anfang pruefen.
          if (/(^|\/)cart\/?$/.test(window.location.pathname)) {
            window.location.reload();
            return;
          }
          // Im Pop-up Inhalt und Summe neu laden
          // (kurz warten, damit der Haken sichtbar bleibt)
          if (btn.closest('cart-drawer')) setTimeout(drawerNeuLaden, 700);
        })
        .catch(function () {
          btn.textContent = urspruenglich;
          btn.disabled = false;
        });
    });

    // Pfeile an den Enden ausgrauen
    var pfeileAbgleichen = function (liste) {
      var box = liste.closest('.fourp-upsell');
      if (!box) return;
      var vor = box.querySelector('.fourp-upsell__pfeil[data-richtung="-1"]');
      var nach = box.querySelector('.fourp-upsell__pfeil[data-richtung="1"]');
      if (vor) vor.disabled = liste.scrollLeft < 4;
      if (nach) nach.disabled = liste.scrollLeft + liste.clientWidth >= liste.scrollWidth - 4;
    };
    document.addEventListener(
      'scroll',
      function (e) {
        if (e.target.classList && e.target.classList.contains('fourp-upsell__liste')) pfeileAbgleichen(e.target);
      },
      true
    );
    var alleAbgleichen = function () {
      document.querySelectorAll('.fourp-upsell__liste').forEach(pfeileAbgleichen);
      upsellKartenAktualisieren();
    };
    // Variantenwechsel auf der Produktseite: Hoes-Vorschlag mitziehen
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, variant-radios, product-form, .product-form__input')) {
        setTimeout(upsellKartenAktualisieren, 150);
      }
    });
    alleAbgleichen();
    new MutationObserver(alleAbgleichen).observe(document.body, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------
     3b · Passende Variante fuer den Zusatzverkauf
     Hoezen gibt es je Maat (135x200 / 150x220) und Systeem (Gravity®
     Lussensysteem / Balance® Ritssysteem). Abgeglichen wird ueber die
     Werte, nicht ueber Optionsnamen, die je Sprache anders heissen.
     ------------------------------------------------------------------ */
  var GROESSE = /(\d{2,3})\s*x\s*(\d{2,3})/i;

  function groesseVon(optionen) {
    for (var i = 0; i < (optionen || []).length; i++) {
      var m = String(optionen[i]).match(GROESSE);
      if (m) return { schluessel: m[1] + 'x' + m[2], text: String(optionen[i]) };
    }
    return null;
  }

  function istHoesOption(wert) {
    return /gravity®|balance®/i.test(String(wert));
  }

  function lesen(json) {
    try {
      return JSON.parse(json || 'null');
    } catch (err) {
      return null;
    }
  }

  // Welche Deken ist der Bezug? Produktseite: gerade gewaehlte Variante.
  // Warenkorb: erste Deken im Korb (Hoezen selbst zaehlen nicht).
  function upsellBezug(box) {
    var k = lesen(box && box.dataset.kontext);
    if (!k) return null;
    if (k.varianten) {
      var feld = document.querySelector('product-form input[name="id"], form[data-type="add-to-cart-form"] [name="id"]');
      var opt = (feld && k.varianten[feld.value]) || k.varianten[Object.keys(k.varianten)[0]];
      if (!opt || opt.some(istHoesOption)) return null;
      var g = groesseVon(opt);
      return g ? { groesse: g, balance: /balance/i.test(k.typ) } : null;
    }
    if (k.korb) {
      for (var i = 0; i < k.korb.length; i++) {
        var z = k.korb[i];
        if ((z.optionen || []).some(istHoesOption)) continue;
        var gz = groesseVon(z.optionen);
        if (gz) return { groesse: gz, balance: /balance/i.test(z.typ) };
      }
    }
    return null;
  }

  // Ergebnis: Variante zum Einlegen, oder 'kiezen' fuer die Produktseite
  function upsellWahl(karte) {
    var vs = lesen(karte.dataset.varianten) || [];
    var verfuegbar = vs.filter(function (v) {
      return v.a;
    });
    if (vs.length === 1) return verfuegbar[0] || 'kiezen';

    var istHoes = vs.some(function (v) {
      return v.o.some(istHoesOption) && groesseVon(v.o);
    });
    if (!istHoes) return 'kiezen';

    var bezug = upsellBezug(karte.closest('.fourp-upsell'));
    if (!bezug) return 'kiezen';

    var treffer = verfuegbar.filter(function (v) {
      var g = groesseVon(v.o);
      var systeem = v.o.some(function (o) {
        return bezug.balance ? /balance®/i.test(o) : /gravity®/i.test(o);
      });
      return g && g.schluessel === bezug.groesse.schluessel && systeem;
    });
    return treffer[0] || 'kiezen';
  }

  // Preis und Hinweis "Past bij je deken · 150x220 cm" an die Wahl anpassen.
  // Nur schreiben, wenn sich etwas aendert, sonst loest der
  // MutationObserver sich selbst endlos aus.
  function upsellKartenAktualisieren() {
    document.querySelectorAll('.fourp-upsell__item[data-varianten]').forEach(function (karte) {
      var wahl = upsellWahl(karte);
      var hinweis = karte.querySelector('.fourp-upsell__past');
      var preis = karte.querySelector('.fourp-upsell__preis');
      var btn = karte.querySelector('.fourp-upsell__btn');
      var istHoes = (lesen(karte.dataset.varianten) || []).some(function (v) {
        return v.o.some(istHoesOption);
      });

      if (wahl && wahl !== 'kiezen') {
        if (btn && btn.getAttribute('data-variant-id') !== String(wahl.id)) btn.setAttribute('data-variant-id', wahl.id);
        var html = '<strong>' + wahl.p + '</strong>' + (wahl.c ? '<s>' + wahl.c + '</s>' : '');
        if (preis && preis.innerHTML !== html) preis.innerHTML = html;
        if (hinweis && istHoes) {
          var g = groesseVon(wahl.o);
          var text = txtOder('past', 'Past bij je deken · {maat}').replace('{maat}', g ? g.text : '');
          if (hinweis.textContent !== text) hinweis.textContent = text;
          if (hinweis.hidden) hinweis.hidden = false;
        }
      } else if (hinweis && !hinweis.hidden) {
        hinweis.hidden = true;
      }
    });
  }

  // Warenkorb-Pop-up neu rendern, wie es das Theme nach eigenen Aenderungen
  // tut (Section Rendering API). Faellt still zurueck, wenn das Theme die
  // Funktion nicht anbietet.
  function drawerNeuLaden() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.getSectionsToRender !== 'function') return;
    var ids = drawer.getSectionsToRender().map(function (s) {
      return s.id;
    });
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        return fetch('?sections=' + ids.join(','))
          .then(function (r) {
            return r.json();
          })
          .then(function (sections) {
            cart.sections = sections;
            drawer.renderContents(cart);
          });
      })
      .catch(function () {});
  }

  function aktualisiereWarenkorbZahl() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span:first-child, .cart-count-bubble').forEach(function (el) {
          if (el.children.length === 0) el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------------
     4 · Warenkorb: englische Reste der Rabatt-App uebersetzen
     Die App zeigte "Total" und "Saving" mitten im niederlaendischen Shop.
     Der Rabatt selbst bleibt unangetastet, nur die Beschriftung wird
     angeglichen.
     ------------------------------------------------------------------ */
  function warenkorbBeschriftung() {
    // Im englischen Shop sind "Total" und "Saving" korrekt. Dort nichts tun,
    // sonst wird die englische Fassung kaputtuebersetzt.
    var sprache = (T.sprache || document.documentElement.lang || '').toLowerCase();
    if (sprache.indexOf('en') === 0) return;

    var ersetzungen = [
      [/^\s*Total\s*$/i, txtOder('kortingOrigineel', 'Oorspronkelijke prijs')],
      [/^\s*Saving[s]?\s*$/i, txtOder('kortingBespaart', 'Je bespaart')],
      [/^\s*You save\s*$/i, txtOder('kortingBespaart', 'Je bespaart')],
    ];

    var anwenden = function () {
      document
        .querySelectorAll('[class*="discounty"] *, .cart__footer *, .totals *, .cart-drawer *')
        .forEach(function (el) {
          if (el.children.length !== 0) return;
          var t = el.textContent;
          if (!t || t.length > 24) return;
          for (var i = 0; i < ersetzungen.length; i++) {
            if (ersetzungen[i][0].test(t)) {
              el.textContent = ersetzungen[i][1];
              return;
            }
          }
        });
    };

    anwenden();
    // Dauerhaft beobachten, aber gebuendelt: Das Warenkorb-Pop-up wird nach
    // jeder Aenderung neu gerendert und die Rabatt-App schreibt dann wieder
    // "Total" und "Saving". Vorher endete die Beobachtung nach 12 Sekunden.
    var geplant = false;
    var beob = new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () {
        geplant = false;
        anwenden();
      });
    });
    beob.observe(document.body, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------
     5 · Abgelaufener Countdown
     Wenn das hinterlegte Enddatum in der Vergangenheit liegt, zeigte das
     Theme 00:00:00:00. Das liest sich wie ein beendetes Angebot. In dem
     Fall wird die Zahlenreihe ausgeblendet.
     ------------------------------------------------------------------ */
  function countdownPruefen() {
    document.querySelectorAll('countdown-timer, .js-countdown').forEach(function (cd) {
      var pruefen = function () {
        var zahlen = Array.prototype.filter
          .call(cd.querySelectorAll('*'), function (el) {
            return el.children.length === 0 && /^\d{1,3}$/.test(el.textContent.trim());
          })
          .map(function (el) {
            return parseInt(el.textContent.trim(), 10);
          });
        if (zahlen.length >= 3) {
          var summe = zahlen.reduce(function (a, b) {
            return a + b;
          }, 0);
          cd.classList.toggle('fourp-countdown-abgelaufen', summe === 0);
        }
      };
      pruefen();
      setTimeout(pruefen, 1500);
    });
  }

  /* ------------------------------------------------------------------
     6 · Kleinere Miniaturen am Desktop (Kundenwunsch 09.10.2026)
     Das Theme zeigt fest 3 Miniaturen, die sind fast ein Drittel so hoch
     wie das Hauptbild. Mit 5 pro Reihe bleibt mehr Hoehe fuer das
     Hauptbild, das jetzt die volle Spaltenbreite nutzt (siehe 4p-cro.css).
     Das Theme baut den Slider bei Variantenwechsel neu, daher wird nach
     jedem Wechsel erneut angepasst.
     ------------------------------------------------------------------ */
  function miniaturenKleiner() {
    var ANZAHL = 5;
    var anpassen = function () {
      document
        .querySelectorAll('.product__outer--slider-previews .js-media-sublist')
        .forEach(function (el) {
          var sw = el.swiper;
          if (!sw || !sw.params) return;
          var bp = sw.params.breakpoints && sw.params.breakpoints[1200];
          if (!bp || bp.slidesPerView === ANZAHL) return;
          bp.slidesPerView = ANZAHL;
          sw.currentBreakpoint = null;
          sw.setBreakpoint();
          sw.update();
        });
    };
    anpassen();
    // Theme ruft beim Laden nach 800 ms noch einmal update() auf
    setTimeout(anpassen, 1000);
    document.addEventListener('change', function () {
      setTimeout(anpassen, 1000);
    });
  }

  ready(function () {
    bewertungVerlinken();
    stickyKaufleiste();
    upsellVerdrahten();
    warenkorbBeschriftung();
    countdownPruefen();
    miniaturenKleiner();

  });
})();
